  <template>
  <figure 
    @click.stop="popsOut"
    class="regular"
    :class="bg ? `gradient-${bg}`: ''">
    
    <header>
      <font-awesome-icon :icon="icon" />
      <h4>{{title}}</h4>
    </header>
      <!-- <p
        v-if="descIsVisible">{{text}}</p> -->
  </figure>
</template>

<script>
export default {
  name: 'data-grid',
  props: ['bg','icon','title', 'number', 'text'],
  methods: {
    popsOut: function(event) {
      event.currentTarget.classList.add('test')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_mixins.scss';
@import '../../../styles/gradients.scss';

figure {
  max-width: 100%;
  min-height: calc((100vw/8)*2);
  background: map-get($colors--accents, 'second');
  @include border-radius;
  cursor: pointer;
  padding: $default_vmin;
  margin-bottom: $default_vmin;
  
  header {
    display: flex;
    align-items: center;
    text-align: left;

    .svg-inline--fa {
      color: $gray_light_1;
      padding-right: 1rem;
      margin-right: 1rem;
      font-size: 3rem;
      border-right: $default_border $gray_light_1;
    }

    h4 {
      font-size: 2.125rem;
      font-weight: 400;
      color: $white;
      padding-left: 1rem;
    }
  }

  p {
    margin-top: 1rem;
    font-size: 1rem;
    color: $white;
    font-weight: 500;
  }

  &.regular {
    display: flex;
    flex-direction: column; 
    justify-content: flex-end;

    header {
      display: block;

      .svg-inline--fa  {
        padding-right: 0;
        margin-right: 0;
        border: none;
      }
      h4 {
        border-top: $default_border $gray_light_1;
        padding-left: 0;
        padding-top: 1rem;
        margin-top: 1rem;
      }
    }
  }

  &:nth-child(3n) {
    margin-right: 0;
  }

  img {
    max-width: 80px;
  }
}
</style>

